import {
  NOC_ALERT_SEVERITY_META,
  NOC_ALERT_STATUS_META,
  NOC_ALERT_TYPE_META,
  NOC_CONNECTOR_STATE_META,
  NOC_SEMAPHORE_META,
  NOC_STATION_STATE_META,
} from '@goelectric/ui-components';
import type {
  NocAlertSeverity,
  NocAlertStatus,
  NocAlertType,
  NocConnectorState,
  NocSemaphore,
  NocStationState,
} from '@goelectric/shared-types';
import { StatusBadgeShell, StatusIcon, useStatusColor } from '@/components/StatusBadgeShell';

/**
 * Badges de estado del NOC: **color + icono + texto** (nunca solo color, WCAG).
 * La primitiva (`StatusBadgeShell`) es compartida con Aliados.
 */
export function StationStateBadge({ state, forceDark = false }: { state: NocStationState; forceDark?: boolean }) {
  const meta = NOC_STATION_STATE_META[state];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}

export function SemaphoreBadge({
  semaphore,
  forceDark = false,
  withLabel = true,
}: {
  semaphore: NocSemaphore;
  forceDark?: boolean;
  withLabel?: boolean;
}) {
  const meta = NOC_SEMAPHORE_META[semaphore];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={withLabel ? meta.label : ''}
      title={`Semáforo ${meta.label}: ${meta.description}`}
    />
  );
}

export function AlertSeverityBadge({ severity, forceDark = false }: { severity: NocAlertSeverity; forceDark?: boolean }) {
  const meta = NOC_ALERT_SEVERITY_META[severity];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}

export function AlertStatusBadge({ status, forceDark = false }: { status: NocAlertStatus; forceDark?: boolean }) {
  const meta = NOC_ALERT_STATUS_META[status];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}

export function AlertTypeBadge({ type, forceDark = false }: { type: NocAlertType; forceDark?: boolean }) {
  const meta = NOC_ALERT_TYPE_META[type];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}

export function ConnectorStateBadge({
  state,
  forceDark = false,
}: {
  state: NocConnectorState;
  forceDark?: boolean;
}) {
  const meta = NOC_CONNECTOR_STATE_META[state];
  const color = useStatusColor(meta.color, meta.colorDark, forceDark);
  return (
    <StatusBadgeShell
      color={color}
      icon={<StatusIcon iconKey={meta.iconKey} />}
      label={meta.label}
      title={`${meta.label}: ${meta.description}`}
    />
  );
}
